<template>
  <div v-if="info" class="tms-synced-badge" :title="info.title">
    <span class="tsb-icon">⇄</span>
    <span class="tsb-text">
      <strong>{{ info.title }}.</strong> {{ info.text }} Кто: {{ info.who }}.
    </span>
    <KbHint article="tms-synced" label="Как это работает" />
    <router-link :to="info.logLink" class="tsb-link">Журнал TMS</router-link>
  </div>
</template>

<script>
import { computed } from 'vue'
import { tmsSyncInfo } from '@/pages/trip/helpers/tmsSynced.mjs'
import KbHint from '@/components/KbHint.vue'

export default {
  name: 'TmsSyncedBadge',
  components: { KbHint },
  props: ['trip', 'executor'],
  setup(props) {
    const info = computed(() => tmsSyncInfo(props.trip, props.executor))
    return { info }
  },
}
</script>

<style scoped>
.tms-synced-badge {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: 8px 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fff7e6;
  border: 1px solid #f5c26b;
  color: #5c3d00;
  font-size: 13px;
  line-height: 1.4;
}
.tsb-icon { font-weight: 700; }
.tsb-link { white-space: nowrap; margin-left: auto; color: #4f46e5; }
</style>
